module.exports = __webpack_public_path__ + "img/sec-222-hanyang.58ce161a.svg";